import React from 'react'
import React from 'react'
import { EcomDataLayerHub } from '../../javascript/analytics/ecommerceDataLayerEventHub.services'
import { buildDateRangeString, getDateTimeEventLocation } from '../helpers/helpers'
import { IDateTimeEvent, IEpiProps, IEventRegistrationRefreshModel, IUserSelections, StepConstants } from '../models/event-reg-refresh-models'
import { useEventRegRefreshContext, useEventRegRefreshDispatch } from '../reducers/event-reg-refresh-reducers'
import { Alert } from './alert'

interface IContextProps {
  epiProps: IEpiProps
  currentStep: string
  userSelections: IUserSelections
  eventRegistrationRefreshModel: IEventRegistrationRefreshModel
}

interface IProps {
  dateTimeEvent: IDateTimeEvent
  onSelect: (event: IDateTimeEvent) => void
  isSelected: boolean
  isReviewStep?: boolean
  isAddOn?: boolean
  isShareSelections?: boolean
}

export const DateTimeCard = (props: IProps) => {
  const { epiProps, userSelections, eventRegistrationRefreshModel }: IContextProps = useEventRegRefreshContext()!
  const dispatch = useEventRegRefreshDispatch()!

  let showSelectButton = (props.isReviewStep === false || props.isReviewStep === undefined) && (props.isShareSelections === false || props.isShareSelections === undefined);
  let showEditProgramButton = props.isReviewStep == true && props.isAddOn == false;
  let showRemoveAddOnButton = props.isReviewStep == true && props.isAddOn == true;
  let showCanadianCurrency = eventRegistrationRefreshModel.currency === "CAD";

  function navigateToStep(step: string) {
    dispatch({
      type: 'updateCurrentStep',
      data: step,
    })
  }

  function removeAddOnFromUserSelections() {
    dispatch({
      type: 'updateUserSelections',
      data: {
        ...userSelections,
        userAddOnProgramSelections: [],
        userAddOnProgramDateTimeSelection: undefined
      }
    });
  }

  return (
    <div className={`card ${props.isSelected ? "card-selected" : ""}`} data-event-number={props.dateTimeEvent.eventNumber}>
      <div className="card-dt-layout">
        <div className="card-dt-layout-content">
          <div>
            <h3 className="card-header-title">
              {getDateTimeEventLocation(props.dateTimeEvent, epiProps.virtualLocationTextDateTimeCard)}
            </h3>
            {eventRegistrationRefreshModel.showPrice && (
              <div className="card-legend-item card-header-subtitle">
                <span className="card-legend-item-icon card-dt-layout-legend-item-icon-price">
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#dollar-icon" />
                  </svg>
                </span>
                <p className="h6-style ">${props.dateTimeEvent.price.toLocaleString()}{showCanadianCurrency ? " " + eventRegistrationRefreshModel.currency : ""}{epiProps.costPerAttendeeLabelDateTimeCard}</p>
              </div>
            )}
            <div className="card-legend-row">
              <div className="card-legend-item">
                <span className="card-legend-item-icon">
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-calendar" />
                  </svg>
                </span>
                <p className="h6-style">{buildDateRangeString(props.dateTimeEvent.days, eventRegistrationRefreshModel.selectedLanguage)}</p>
              </div>
              <div className="card-legend-item">
                <span className="card-legend-item-icon">
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-language" />
                  </svg>
                </span>
                <p className="h6-style">{props.dateTimeEvent.spokenLanguage}</p>
              </div>
            </div>
          </div>

          <div className="card-dt-layout-actions-mobile">
            {props.dateTimeEvent.isFull == false && showSelectButton && (
              <button
                onClick={() => props.onSelect(props.dateTimeEvent)}
                className={`btn-primary ${props.isSelected ? "selected" : ""}`}
              >
                {props.isSelected ? epiProps.selectedButtonText : epiProps.selectButtonText}
                {props.isSelected && (
                  <svg className="svg-icon" aria-hidden="true" focusable="false">
                    <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-checkmark" />
                  </svg>
                )}
              </button>
            )}
            {showEditProgramButton && (
              <button className="btn-primary" onClick={() => { navigateToStep(StepConstants.ProgramStep); EcomDataLayerHub.reviewEditClick("Program") }}>{epiProps.editSelectionCtaText}</button>
            )}
            {showRemoveAddOnButton && (
              <button onClick={() => removeAddOnFromUserSelections()}>X</button>
            )}
          </div>

          <div>
            {props.dateTimeEvent.isVirtual == true && (
              <p className="card-dt-layout-address">{epiProps.virtualEventMessageDateTimeCard}</p>
            )}
            {props.dateTimeEvent.isVirtual == false && (
              <p className="card-dt-layout-address">
                {props.dateTimeEvent.facility && <>{props.dateTimeEvent.facility}<br /></>}
                {props.dateTimeEvent.address1} {props.dateTimeEvent.address2}<br />
                {props.dateTimeEvent.city}, {props.dateTimeEvent.state} {props.dateTimeEvent.zip}
              </p>
            )}
            {props.dateTimeEvent.days && props.dateTimeEvent.days.length > 0 && (
              <ul>
                {props.dateTimeEvent.days.map((day, index) => (
                  <li key={index}>{day}</li>
                ))}
              </ul>
            )}
            <p className="card-dt-layout-address">{props.dateTimeEvent.timeZone}</p>
          </div>
        </div>
        <div className="card-dt-layout-actions">
          {props.dateTimeEvent.isFull == false && showSelectButton && (
            <button
              onClick={() => props.onSelect(props.dateTimeEvent)}
              className={`btn-primary ${props.isSelected ? "selected" : ""}`}
            >
              {props.isSelected ? epiProps.selectedButtonText : epiProps.selectButtonText}
              {props.isSelected && (
                <svg className="svg-icon" aria-hidden="true" focusable="false">
                  <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#icon-checkmark" />
                </svg>
              )}
            </button>
          )}
          {showEditProgramButton && (
            <button className="btn-primary" onClick={() => { navigateToStep(StepConstants.ProgramStep); EcomDataLayerHub.reviewEditClick("Program") }}>{epiProps.editSelectionCtaText}</button>
          )}
          {showRemoveAddOnButton && (
            <button className="btn-primary btn-remove" onClick={() => removeAddOnFromUserSelections()}>
              <span className="visually-hidden">Remove Addon</span>
              <svg className="svg-icon" aria-hidden="true" focusable="false">
                <use xmlnsXlink="ttp://www.w3.org/2000/xlink" xlinkHref="#trash-icon" />
              </svg>
            </button>
          )}
        </div>
      </div>
      {props.dateTimeEvent.isFull == true && (
        <Alert variant="warning">
          <p><strong>{epiProps.waitlistMessageHeadingDateTimeCard}</strong></p>
          <p>{epiProps.waitlistMessageDateTimeCard}</p>
        </Alert>
      )}
    </div>
  )
}
